module.exports = "<status-widget widget-name=\"{{'dashboard.panel.tasks.title'|translate}}\"\n               widget-state=\"app.jobs\"\n               items=\"$ctrl.data\"\n               start-time=\"$ctrl.startTime\"\n               chart-colors=\"$ctrl.graphColors\"\n               widget-title-tooltip=\"{{::'dashboard.panel.tasks.descriptionTooltip'|translate}}\"\n               history-chart=\"true\"\n               cursor-pointer=\"true\"\n               render-counter=\"$ctrl.renderCounter\">\n</status-widget>"


//////////////////
// WEBPACK FOOTER
// ./src/azurebackup/views/dashboard/components/jobsWidget/jobsWidget.template.html
// module id = 497
// module chunks = 0